var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.535 21.684h-67.07c-4.003 0-7.26 3.257-7.26 7.261v42.111c0 4.004 3.257 7.261 7.26 7.261h67.07c4.003 0 7.26-3.257 7.26-7.261V28.944c0-4.004-3.257-7.261-7.26-7.261Zm4.26 49.372a4.265 4.265 0 0 1-4.26 4.261h-67.07a4.265 4.265 0 0 1-4.26-4.261V35.935l36.982 23.829a1.5 1.5 0 0 0 1.614.007l36.993-23.389v34.674Zm0-38.223L50.008 56.725 12.205 32.367v-3.422a4.265 4.265 0 0 1 4.26-4.261h67.07a4.265 4.265 0 0 1 4.26 4.261v3.889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContact);
export default __webpack_public_path__ + "static/media/email-contact.c432bf6c0b1fbbdd9a82bd8d23531315.svg";
export { ForwardRef as ReactComponent };